import * as auth from "firebase/auth";
import { UserSystemRole } from "../enums/UserSystemRole";


export class CurrentUser {
    roles: UserSystemRole[] = [];
    systemRole = "";
    userId = "";
    firebaseUser: auth.User | null = null;

    constructor(roles: UserSystemRole[], systemRole: string, userId: string) {
        this.roles = roles;
        this.systemRole = systemRole;
        this.userId = userId;
    }
    isAdmin() {
        return this.roles && (this.roles.includes(UserSystemRole.Planner) || this.roles.includes(UserSystemRole.Admin));
    }

    hasEditPermission() {
        return this.isAdmin() || this.roles && this.roles.includes(UserSystemRole.ProjectManager);
    }

    isLead() {
        return this.hasEditPermission() || this.roles && this.roles.includes(UserSystemRole.Lead);
    }
}
